import BasePageView from "components/core/BasePageView/BasePageView";
import useSellerContext from "hooks/useSellerContext";
import useGrnListLogic from "./useGrnListLogic";
import GrnListDesktop from "./GrnListDesktop";
import GrnListMobile from "./GrnListMobile";

const GrnListView = () => {
  const vm = useGrnListLogic();
  const { currentSellerDetail, allSellersDetails, handleProfileNavigate } = useSellerContext();

  return (
    <BasePageView
      DesktopView={GrnListDesktop}
      MobileView={GrnListMobile}
      viewProps={vm}
      headerProps={{
        showSubHeader: true,
        sellerDetail: currentSellerDetail,
        allSellerDetails: allSellersDetails,
        handleProfile: handleProfileNavigate,
      }}
    />
  );
};

export default GrnListView;
